export default {
  title: 'Error',
  error: 'Sorry, something went wrong.',
};
